import {COMPANY_TYPE} from './COMPANY_TYPE';
import {SELF_EMPLOYED_TYPE} from './SELF_EMPLOYED_TYPE';

export const TENANT_TYPE_OPTIONS = [SELF_EMPLOYED_TYPE, COMPANY_TYPE] as const;
